export default __webpack_public_path__ + "static/assets/a11919e102077f40302da55fb9150440.svg";